module.exports = __webpack_public_path__ + "02_glasses_red.da653b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/02_glasses_red.png
// module id = Ijq4
// module chunks = 0